import "./Unsubscribe.css";
import AccountsService from "../../../services/AccountsService";
import EvergentErrors from "../../../services/Evergent/EvergentErrors.ts";

export async function UnsubscribeHandle(navigate, subscription, successfulFlow){

  return await AccountsService.unsubscribeSubscription({})
      .then((r) => {
        window.addEventListener("message", function handleMessage(event){
          const iframeUrl = new URL(r.data.uri);
          if (!iframeUrl || (event.origin !== iframeUrl?.origin && event.origin !== window.location.origin)) {
            return;
          }

          let data;
          try {
            data = JSON.parse(event.data);
          }catch (e){
            data = event.data;
          }

          if(data?.status !== undefined) {
            console.log("Successful flow", parseInt(data?.status))
            window.removeEventListener("message", handleMessage);
            if ((parseInt(data.status) === 1)) {
              successfulFlow();
              navigate("/Account")
            }else if(parseInt(data.status) === 0){
              if(data.errorCode === EvergentErrors.REQUEST_TERMINATED.value){
                window.location.replace("/Account"); //replace so user cant go back to /unsubscribe without any state
              }
            }else if(parseInt(data.status) === 400){
              window.removeEventListener("message", handleMessage);
            }
          }
        });

        navigate("/Unsubscribe", {state: { uri: r.data.uri}})
      })
}

export default UnsubscribeHandle;
